export default "__VITE_ASSET__B7q2LRIH__"